<template>
    <div class="filter-min-max">
        <div class="filter-label" @click="showOptions = !showOptions">
            {{ valueLabel }}
        </div>
        <div
            class="filter-options"
            v-if="showOptions"
            v-click-outside="clickedOutsideOptions"
            :style="{ width: options.optionsWidth + 'px' }"
        >
            <div class="fields">
                <div class="field">
                    <label :for="`filter-${name}-min`">{{ t('reportFilters-min') }}:</label>
                    <input type="tel" v-model="min" v-mask="options.mask" :name="`${name}-min`" :id="`filter-${name}-min`" />
                </div>
                <div class="field">
                    <label :for="`filter-${name}-max`">{{ t('reportFilters-max') }}:</label>
                    <input type="tel" v-model="max" v-mask="options.mask" :name="`${name}-max`" :id="`filter-${name}-max`" />
                </div>
            </div>
            <div class="filter-actions">
                <button
                    type="button"
                    class="cancelBtn btn btn-sm btn-default"
                    @click="cancel"
                >
                    {{ t('reportFilters-close') }}
                </button>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.field {
    display: flex;
    label {
        width: auto;
        display: block;
        margin-right: 10px;
    }
}
input {
    border: none;
    border-bottom: 1px solid #ddd;
    box-shadow: none;
    font-size: 13px;
    flex-grow: 1;
    width: 100%;
    &:focus {
        outline: none;
        box-shadow: none;
        border: none;
        border-bottom: 1px solid #ddd;
    }
}
</style>
<script>
export default {
    name: "min-max",
    props: {
        options: {
            type: Object,
            default: () => ({
                mask: "R$ ######,##",
                optionsWidth: 300,
            }),
        },
        name: {
            type: String,
            default: "min-max",
        },
        currentValue: {
            type: Object,
            default: () => ({
                min: "",
                max: "",
            }),
        },
    },
    data() {
        return {
            showOptions: false,
            clickedOutsideOptions: () => {},
            value: "",
            changedValue: false,
            min: null,
            max: null,
        };
    },
    mounted() {
        if (this.currentValue) {
            this.max = this.currentValue.max || null;
            this.min = this.currentValue.min || null;
        }
        if (this.value.length > 0) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        cancel() {
            this.showOptions = false;
        },
        changed() {
            this.$emit("changed", this.value);
        },
        checkValuesOrder() {
            if (this.max && this.maxFloat < this.minFloat) {
                let max = this.max;
                let min = this.min;
                this.max = min;
                this.min = max;
            }
        },
        setValue() {
            this.checkValuesOrder();
            this.value = {
                min: String(this.min)
                    .replace(/[^-0-9,]/gi, "")
                    .replace(",", "."),
                max: String(this.max)
                    .replace(/[^-0-9,]/gi, "")
                    .replace(",", "."),
            };
        },
    },
    computed: {
        maxFloat() {
            return parseFloat(
                String(this.max)
                    .replace(/[^-0-9,]/gi, "")
                    .replace(",", "."),
            );
        },
        minFloat() {
            return parseFloat(
                String(this.min)
                    .replace(/[^-0-9,]/gi, "")
                    .replace(",", "."),
            );
        },
        valueLabel() {
            const isEmpty = (v) => v === null || v === "" || v === undefined;
            if (isEmpty(this.min) && isEmpty(this.max)) {
                return this.t('reportFilters-enter_values');
            } else if (isEmpty(this.min) && !isEmpty(this.max)) {
                return this.t('reportFilters-up_to', [this.max]);
            } else if (!isEmpty(this.min) && isEmpty(this.max)) {
                return this.t('reportFilters-from', [this.min]);
            } else {
                return this.t('reportFilters-between', [this.min, this.max]);
            }
        },
    },
    watch: {
        showOptions() {
            this.setValue();
            if (this.showOptions) {
                window.setTimeout(() => {
                    this.clickedOutsideOptions = () => {
                        if (this.showOptions) {
                            this.cancel();
                        }
                    };
                }, 100);
            } else {
                this.clickedOutsideOptions = () => {};
            }
        },
        value() {
            this.changed();
        },
    },
};
</script>
